import React from 'react';
import { useMediaQuery } from '../useMediaQuery/useMediaQuery.js';
import { ViewportContext } from './ViewportContext.js';

function ViewportProvider({ children, defaultType, }) {
    const isMobile = useMediaQuery('(max-width: 767px)', defaultType === 'mobile');
    const isTablet = useMediaQuery('(min-width: 768px) and (max-width: 979px)', defaultType === 'tablet');
    const isDesktop = useMediaQuery('(min-width: 980px)', defaultType === 'desktop');
    let viewport = defaultType;
    if (isMobile) {
        viewport = 'mobile';
    }
    else if (isTablet) {
        viewport = 'tablet';
    }
    else if (isDesktop) {
        viewport = 'desktop';
    }
    return (React.createElement(ViewportContext.Provider, { value: {
            viewport,
            isDesktop,
            isMobile,
            isTablet,
        } }, children));
}

export { ViewportProvider };
//# sourceMappingURL=ViewportProvider.js.map
